import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { SimpleGrid, Stack, type StackProps, Text, rem } from '@mantine/core';
import { BunkerRewardItem } from './BunkerRewardItem';
import { bunkerRewardData } from './data';
export const BunkerRewardsSection: React.FC<StackProps> = ({
  ...props
}) => {
  const {
    i18n
  } = useLingui();
  return <Stack mb={10} {...props}>
      <Text fz={{
      base: 21,
      sm: 18,
      lg: 32
    }} lh={{
      base: rem(21),
      sm: rem(18),
      lg: rem(32)
    }} className={gunterzBold.className} c="var(--text-white)" ta={{
      base: 'left',
      lg: 'center'
    }}>
        {i18n._('REWARD')}
      </Text>

      <SimpleGrid cols={{
      base: 2,
      sm: 1,
      lg: 9
    }}>
        {bunkerRewardData.map(item => <BunkerRewardItem key={item.id} {...item} />)}
      </SimpleGrid>
    </Stack>;
};